import { getAntiForgeryToken, legacyAccountAPI } from '../apis/authApi/authAPI';
import type { UserInfoViewModelApp } from '../apis/authApi/types';
import isElectron from 'is-electron';
import { localStorageGet } from '../utils/storage';

const getClientType = () => (isElectron() ? 2 : 1); // 0: Mobile, 1: Web, 2: Desktop

export type Legacy2FALoginResponse = {
  TwoFactorAuthCodeRequired: boolean;
  /** @description Truncated string. Like "**012" */
  TwoFactorAuthPhone: string;
  token: string;
  email: string;
  /** @note DEV only */
  code?: string;
};

export const legacyLoginRequest = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  const csrfToken = await getAntiForgeryToken();
  return legacyAccountAPI.performExtra<UserInfoViewModelApp | Legacy2FALoginResponse>({
    method: 'POST',
    extraResource: 'login',
    returnErrorResponseData: true,
    model: {
      email,
      password,
      clientType: getClientType(),
    },
    headers: { 'X-XSRF-Token': csrfToken },
  });
};

export const legacyLogoutRequest = async (): Promise<void> => {
  const csrfToken = await getAntiForgeryToken();
  await legacyAccountAPI.performExtra<UserInfoViewModelApp>({
    method: 'POST',
    extraResource: isElectron() ? `logout?deviceId=${localStorageGet('pushyToken')}` : 'logout',
    headers: { 'X-XSRF-Token': csrfToken },
  });
};

export const convertLegacyCookieToJwt = async () => {
  const response = await legacyAccountAPI.performExtra<{ refreshToken: string }>({
    method: 'GET',
    extraResource: 'cookie-to-jwt',
  });

  if (!('refreshToken' in response)) {
    return {
      error: {
        status: 'error',
        error: undefined,
      },
      response: {} as Response,
    };
  }

  return {
    data: {
      status: 'success',
      data: { refreshToken: response.refreshToken },
    },
    response: {} as Response,
  };
};
